import React from 'react'
import { ExampleWrapperSeamless } from '@/layout-components'
import { usePublicHome } from '@/hooks/usePublicHome'
import PropertySection from '@/housefolios-components/PublicPages/components/PropertySection'
import ProcessSection from '@/housefolios-components/PublicPages/components/ProcessSection'
import ContactSection from '@/housefolios-components/PublicPages/components/ContactSection'

function PublicHomePage(props) {
  const {
    // Data
    properties,
    displayProperties,
    marketplaceVideoURL,
    affiliate,
    urlAffiliate,
    orgName,

    // Form state
    name,
    setName,
    email,
    setEmail,
    phone,
    setPhone,
    message,
    setMessage,

    // Loading states
    loadingMarketPlaceData,
    marketPlaceError,

    // Event handlers
    sendEmail,
  } = usePublicHome(props)

  const urlParams = new URLSearchParams(window.location.search)
  const subdomain = urlParams.get('subdomain') || null
  const subdomainParam = subdomain ? '?subdomain=' + subdomain : ''

  if (marketPlaceError) return `Error! ${marketPlaceError?.message}`

  return (
    <ExampleWrapperSeamless>
      <PropertySection
        properties={properties}
        featuredProperties={props.marketplace?.featuredProperties}
        marketplace={props.marketplace}
        subdomainParam={subdomainParam}
        loading={loadingMarketPlaceData}
      />

      <ProcessSection
        orgName={orgName}
        marketplaceVideoURL={marketplaceVideoURL}
      />

      <ContactSection
        marketplace={props.marketplace}
        orgName={orgName}
        urlAffiliate={urlAffiliate}
        affiliate={affiliate}
        name={name}
        setName={setName}
        email={email}
        setEmail={setEmail}
        phone={phone}
        setPhone={setPhone}
        message={message}
        setMessage={setMessage}
        sendEmail={sendEmail}
      />
    </ExampleWrapperSeamless>
  )
}

export default PublicHomePage
